

<footer class="footer">
  <div class="container">
    <div class="footer-inner">
    
    </div>
    <div class="copyright">
      &copy; 2026 BSIC Gambia Ltd. All rights reserved. Powered by ruecart.com
    </div>
  </div>
</footer>
